/**
 * EMPRICS Cursor Reactor
 * Mouse tracking, parallax, magnetic CTAs
 * Under 2KB gzipped
 */
(function() {
  'use strict';

  // Skip on touch devices and reduced motion
  if ('ontouchstart' in window) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var mouseX = 0;
  var mouseY = 0;
  var rafId = null;

  // Parallax elements
  function updateParallax() {
    var els = document.querySelectorAll('[data-emprics-parallax]');
    var cx = mouseX / window.innerWidth - 0.5;
    var cy = mouseY / window.innerHeight - 0.5;

    els.forEach(function(el) {
      var intensity = parseFloat(el.getAttribute('data-emprics-parallax')) || 20;
      var x = cx * intensity;
      var y = cy * intensity;
      el.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    });

    rafId = null;
  }

  // Magnetic CTA effect
  function handleMagnetic(e) {
    var magnetics = document.querySelectorAll('.emprics-magnetic');
    magnetics.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;
      var distX = e.clientX - centerX;
      var distY = e.clientY - centerY;
      var dist = Math.sqrt(distX * distX + distY * distY);
      var threshold = 120;

      if (dist < threshold) {
        var pull = (threshold - dist) / threshold;
        var moveX = distX * pull * 0.3;
        var moveY = distY * pull * 0.3;
        el.style.transform = 'translate(' + moveX + 'px, ' + moveY + 'px)';
      } else {
        el.style.transform = '';
      }
    });
  }

  document.addEventListener('mousemove', function(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;

    if (!rafId) {
      rafId = requestAnimationFrame(updateParallax);
    }

    handleMagnetic(e);
  }, { passive: true });

})();
